module.exports = __webpack_public_path__ + "static/media/6.797c2465.jpg";